var map = {
	"./about_page.webp": 646,
	"./accounting_and_finance.webp": 965,
	"./amikaur_logo.webp": 803,
	"./analytics.webp": 721,
	"./background_1.webp": 783,
	"./background_2.webp": 94,
	"./background_3.webp": 849,
	"./banking.webp": 675,
	"./company_logo_wothout_text.webp": 729,
	"./engineering.webp": 834,
	"./health_care_it.webp": 101,
	"./hospitals_and_health_care.webp": 373,
	"./human_resources_hr.webp": 285,
	"./information_technology_it.webp": 634,
	"./itemdetail_background.webp": 838,
	"./legal.webp": 12,
	"./loader_gif.gif": 732,
	"./medical_devices.webp": 866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 573;